import { render, staticRenderFns } from "./TextractMappingPage.vue?vue&type=template&id=7da1b715&scoped=true&"
import script from "./TextractMappingPage.vue?vue&type=script&lang=js&"
export * from "./TextractMappingPage.vue?vue&type=script&lang=js&"
import style0 from "./TextractMappingPage.vue?vue&type=style&index=0&id=7da1b715&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1b715",
  null
  
)

export default component.exports